// extracted by mini-css-extract-plugin
export default {"HeaderWrapper":"Header_HeaderWrapper__DmOe8","headerBackground":"Header_headerBackground__bRiwT","sidepaneToggle":"Header_sidepaneToggle__zNxjA","hidden":"Header_hidden__LWXR0"};